export default {
  skillStatus: {
    Validated: 'Validated',
    InProgress: 'In progress',
    NotDiscovered: 'To work on',
    Blocked: 'Blocked',
  },
  // SchoolModulesPage.vue
  schoolModulesPage: {
    recommended: 'recommended',
    verifyLevel: 'Let\'s check your level with some challenges.',
    takeTest: 'Take the Test',
    setAsDefault: 'Set as default level',
    confirmChange: 'Do you confirm this choice? If you change your main level, I will adapt my recommendations accordingly.',
    cancel: 'Cancel',
    yesChange: 'Yes, I change level',
    recommendedModule: 'Recommended module',
    recommendedModules: 'Recommended modules',
    otherModules: 'Other modules',
    finishedModulesList: 'List of completed modules for this level',
    testProfileReminder: 'You can find the test anytime in your profile.',
    modules: 'modules',
    banners: {
      finish: "Congratulations, you have completed all the skills in your level!",
      next: "Next level",
      test: "Let's check your level with some challenges.",
      goToTest: "Take the Test",
    }
  },

  // SchoolModulePage.vue
  schoolModulePage: {
    congratulations: 'Congratulations!',
    moduleFinished: 'You have finished this module!',
    keepGoing: 'Keep it up and you\'ll soon be able to play your favorite songs',
    backToList: 'Back to module list',
    letsGo: 'Let\'s go!'
  },

  // SchoolModulesHeaderBar.vue
  schoolModulesHeaderBar: {
    level: 'Level {level}',
    learningPath: '{level} Path',
    modulesCount: '{finished} / {total} modules'
  },

  // SchoolModuleStepView.vue
  schoolModuleStepView: {
    or: 'or'
  },

  // SchoolLevelUpPopup.vue
  schoolLevelUpPopup: {
    congratulations: 'Congratulations!',
    finishedAllModules: 'You have completed all {level} modules!',
    finishedAllSkillsForLevel: 'You have completed all skills for level {level}!',
    finishedAllModulesForLevel: 'You have completed all {level} modules!',
    readyNextLevel: 'Ready to move to the next level?',
    nextLevelQuestion: 'Ready to move to the next level?',
    maxLevelReached: 'You can now play challenges, learn a song or review lower level modules. We add modules regularly so don\'t hesitate to check if there are new ones from time to time.',
    maxLevelSkills: 'You can now play challenges, learn a song or review lower level skills. We add skills regularly so don\'t hesitate to check if there are new ones from time to time.',
    pieces: 'Songs',
    challenges: 'Challenges',
    nextLevel: 'Next level',
    close: 'Close',
    levelUpNotification: 'Congratulations! You are now level {level}',
    levelUpMessage: 'Congratulations! You are now at the next level!'
  },

  // SchoolVideoPopup.vue
  schoolVideoPopup: {
    skip: 'Skip',
    validate: 'Validate',
    cancel: 'Cancel'
  },

  // SchoolChallengePopup.vue
  schoolChallengePopup: {
    close: 'close',
    premiumOnly: 'All challenges in this step are only available with premium subscription!',
    skipStep: 'Skip step',
    alreadyCompleted: 'You have already completed this challenge! Do you want to replay it or move to the next step?',
    mustComplete: 'You have not completed this challenge, you must complete it to continue!',
    replay: 'Replay',
    play: 'Play',
    validate: 'Validate'
  },

  // SkillCard.vue
  skillCard: {
    videos: '{count} video{plural}',
    skills: '{count} skill{plural}',
    statusNotDiscovered: 'To work on',
    statusDiscovered: 'Discovered',
    statusInProgress: 'In progress',
    statusValidated: 'Validated',
    statusBlocked: 'Blocked'
  },

  skillCategories: {
    filterByHand: 'Filter by hand:',
    allHands: 'All hands',
    leftHand: 'Left hand',
    rightHand: 'Right hand',
    bothHands: 'Both hands'
  },

  // SkillListPage.vue
  skillListPage: {
    loadingSkills: 'Loading skills...',
    noSkills: 'No skills available for this category',
    skillsCount: '{count} skill{plural}',
    seeMore: 'See more',
    seeLess: 'See less'
  },

  // SkillDetailPage.vue
  skillDetailPage: {
    loadingContent: 'Loading content...',
    foundIn: 'I find this skill in:',
    exercises: 'exercise | exercises',
    pieces: 'song | songs',
    challenges: 'challenge | challenges',
    workOnSkill: 'Work on this skill',    skillDifficultyHigher: 'This skill is more difficult than your current level.',
    noExerciseFound: 'I found no exercise to work on this skill at the moment.',    videos: 'Videos',
    completedExercises: 'Completed exercises',
    noCompletedExercises: 'No completed exercises',
    validatedChallenges: 'Validated challenges',
    noCompletedChallenges: 'No completed challenges',
    seeMore: 'See more',
    seeLess: 'See less',
    associatedPieces: 'Associated songs',
    noPiecesAvailable: 'No songs available',
    suggestedExercise: 'Suggested exercise',
    otherExercises: 'Other exercises',
    noExercisesAvailable: 'No exercises available',
    otherChallenges: 'Other challenges',
    noChallengesAvailable: 'No challenges available',
    blockedSkill: "This skill is currently blocked because some necessary skills are not yet validated. It will unlock automatically as you progress."
  },

  // VideoListPage.vue
  videoListPage: {
    loadingSkills: 'Loading skills...',
    noVideos: 'No videos available for this category',
    videosCount: '{count} video{plural}'
  },

  // VideoCard.vue
  videoCard: {
    watchAgain: 'Watch again',
    watch: 'Watch video'
  },

  // VideoDetail.vue
  videoDetail: {
    watchLater: 'Watch later',
    validate: 'Validate',
    ok: 'Ok'
  },

  // SkillBreadcrumbNavigation.vue
  skillBreadcrumbNavigation: {
    categories: 'Categories'
  },

  // SchoolModuleSteps.ts - Exercise types
  exerciseTypes: {
    handprint: 'Hand shape',
    pianisticTechnic: 'Piano technique',
    rhythmic: 'Rhythmic',
    sequence: 'Sequence'
  }
};